import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import api from '../api/api';
// Usamos el logo blanco para que resalte sobre el verde del header
import logoBlanco from '../assets/logoCafe.png'; 

const COLORS = {
    SIERRA_GREEN: '#2E5B2E',
    CANTERA_PINK: '#C19A6B',
    SOFT_CREAM: '#f9f9f513', // Crema suave para el fondo del contenido
    CHARCOAL: '#1F2937',
    WHITE: '#FFFFFF',
    DANGER: '#DC2626',
};

const ClientLayout = ({ title, children }) => {
    const [profile, setProfile] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login', { replace: true });
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            handleLogout();
            return;
        }
        const config = { headers: { Authorization: `Bearer ${token}` } };
        api.get('/profile/me', config)
            .then(res => setProfile(res.data))
            .catch(err => console.error('Error cargando perfil', err));
    }, [navigate]);

    const username = profile ? (profile.firstName && profile.lastName ? `${profile.firstName} ${profile.lastName}` : profile.username) : 'Cliente';
    const displayTitle = title || `Bienvenido, ${username}`;

    return (
        <div style={styles.container}>
            <style>{styles.dotAnimationCss}</style>
            
            <div className="animated-background-dots" style={styles.bgWrapper}>
                
                {/* HEADER UNIFICADO (Fondo Verde Sierra) */}
                <header style={styles.header}>
                    <div style={styles.navInner}>
                        <div style={styles.brand}>
                            <img src={logoBlanco} alt="Xavana Logo" style={styles.logo} />
                            <div style={styles.divider} />
                            <h1 style={styles.titleText}>{displayTitle}</h1>
                        </div>

                        {/* BOTONES UNIFICADOS EN TAMAÑO */}
                        <nav style={styles.buttonGroup}>
                            {location.pathname !== '/bienvenida' && (
                                <button onClick={() => navigate('/bienvenida')} style={styles.navButton}>
                                    Dashboard
                                </button>
                            )}
                            <Link to="/contacto" style={styles.navLinkButton}>Soporte</Link>
                            <button onClick={handleLogout} style={{...styles.navButton, background: COLORS.DANGER}}>
                                Cerrar Sesión
                            </button>
                        </nav>
                    </div>
                </header>

                {/* ÁREA DE CONTENIDO (Fondo Crema Suave) */}
                <main style={styles.mainContent}>
                    <div style={styles.contentCard}>
                        {children}
                    </div>
                </main>

                <footer style={styles.footer}>
                    © {new Date().getFullYear()} Xavana Café - Sistema de Gestión de Clientes
                </footer>
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        background: COLORS.SIERRA_GREEN, // Base verde
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
    },
    bgWrapper: {
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    dotAnimationCss: `
        @keyframes moveDots {
            0% { background-position: 0 0; }
            100% { background-position: 400px 400px; }
        }
        .animated-background-dots::before {
            content: '';
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background-image: radial-gradient(#ffffff10 1px, transparent 1px);
            background-size: 40px 40px;
            animation: moveDots 80s linear infinite;
            z-index: 0;
            pointer-events: none;
        }
    `,
    header: {
        background: COLORS.SIERRA_GREEN,
        padding: '15px 40px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        zIndex: 10,
    },
    navInner: {
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    brand: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
    },
    logo: {
        height: '80px',
        width: 'auto',
    },
    divider: {
        width: '1px',
        height: '30px',
        background: 'rgba(255,255,255,0.3)',
    },
    titleText: {
        color: COLORS.WHITE,
        fontSize: '1.1rem',
        fontWeight: '500',
        margin: 0,
    },
    buttonGroup: {
        display: 'flex',
        gap: '12px',
    },
    // Estilo base para todos los botones de navegación
    navButton: {
        background: COLORS.CANTERA_PINK,
        color: COLORS.WHITE,
        width: '140px', // Tamaño fijo para todos
        height: '42px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.9rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'transform 0.1s, opacity 0.2s',
    },
    navLinkButton: {
        background: COLORS.CANTERA_PINK,
        color: COLORS.WHITE,
        width: '140px', // Mismo tamaño
        height: '42px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.9rem',
        textDecoration: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    mainContent: {
        flex: 1,
        padding: '40px 20px',
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    contentCard: {
        background: COLORS.SOFT_CREAM, // Ya no es blanco puro
        width: '100%',
        maxWidth: '1150px',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
        color: COLORS.CHARCOAL, // Texto oscuro para contraste en el contenido
    },
    footer: {
        textAlign: 'center',
        padding: '20px',
        color: 'rgba(255,255,255,0.5)',
        fontSize: '0.75rem',
    }
};

export default ClientLayout;